import { render, staticRenderFns } from "./AddResourceMenu.vue?vue&type=template&id=fc9a9d22&"
import script from "./AddResourceMenu.vue?vue&type=script&lang=ts&"
export * from "./AddResourceMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AddResourceMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports